<template lang="html">
  <div>
    <div>

  <table class="table table-hover table-sm col-md-11" ref="income" :data="income">
  <thead>
    <div class = "row" slot="header">
      <h3 scope="col">
       Income
      </h3>
    </div>
    <tr>
      <th class="text-center" scope="col">Description</th>
      <th class="text-center" scope="col">Amount</th>
      <th class="text-center" scope="col"></th>
    </tr>
  </thead>
  <tbody>
        <tr v-for="(income, index) in income" v-bind:key="index" >
          <td class="text-center">
            {{income.desc}}
          </td>
          <td class="text-center">
            {{income.amount}}
          </td>
        </tr>
  </tbody>
  </table>
  </div>

  <form v-on:submit.prevent="addincome">
<div class="form-row">
    <div class="form-group col-md-3">
    
      <input type="text" class="form-control" id="description" placeholder="Description" v-model="desc">
    </div>
    <div class="form-group col-md-3">
      <input type="text" class="form-control" id="amount" placeholder="Amount" v-model="amount">
    </div>
    <div class="form-group col-md-3">
      <button type="submit" class="btn btn-primary">Add Income</button>
    </div>
</div>
</form>

  </div>
</template>

<script>
import db from './firebaseInit'
import firebase from 'firebase/app'
require('@firebase/auth');
require('@firebase/database');
require('@firebase/firestore');
require('@firebase/functions');
require('@firebase/messaging');
require('@firebase/storage');
require('@firebase/performance');

export default {
  name: 'income',
  data () {
    return {
      income: [],
      desc : null,
      amount : null
    }
  },
  methods: {
addincome(){
  var user = firebase.auth().currentUser;
  var userId
   if (user != null) {
      userId = user.uid;
      } 
  db.collection('users').doc(userId).collection('income').add({
 
    desc: this.desc,
    amount: parseFloat(this.amount)
  }).then(ref => {
  const data = {
    'id' : ref.id,
    desc: this.desc,
    amount: '$' + parseFloat(this.amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
  }
  this.income.push(data)
  this.desc = ''
  this.amount = ''
})
}
  },
  created (){  
    var userId
  var user = firebase.auth().currentUser;
   if (user != null) {
      userId = user.uid;
      } 
  db.collection('users').doc(userId).collection('income').get().then
  (querySnapshot => {
    querySnapshot.forEach(doc => {
      //console.log(doc.data());
      const data = {
        'id' : doc.id,
        'desc' : doc.data().desc,
        'amount' : '$' + parseFloat(doc.data().amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      }
      this.income.push(data)
      //console.log(data)
    })
  }
  )
  }
}
</script>